// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slot-box[data-v-b29b3b64] {\n  display: inline-block;\n  float: right;\n  margin-bottom: 2.66667vw;\n}", ""]);
// Exports
module.exports = exports;
